export default function ShippingSection() {
  const methods = [
    { method: "EMS", time: "7-15 Days", cost: "$$", bestFor: "Medium parcels, good balance" },
    { method: "E-EMS", time: "7-15 Days", cost: "$", bestFor: "Budget-friendly shipping" },
    { method: "DHL", time: "3-7 Days", cost: "$$$", bestFor: "Fastest delivery, urgent orders" },
    { method: "UPS", time: "4-8 Days", cost: "$$$", bestFor: "Reliable express shipping" },
    { method: "SAL", time: "15-30 Days", cost: "$", bestFor: "Large hauls, cheapest option" },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Save Money
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Sugargoo Shipping Cost Guide <span className="text-primary-500">2026</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Understanding shipping costs is essential for getting the best value. Compare different shipping methods, delivery times, and estimated costs to choose the right option for your order.
          </p>
        </div>

        <div className="rounded-lg border border-background-200/70 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 text-sm font-semibold text-foreground-700">Shipping Method</th>
                <th className="text-left px-5 py-3.5 text-sm font-semibold text-foreground-700">Delivery Time</th>
                <th className="text-left px-5 py-3.5 text-sm font-semibold text-foreground-700">Estimated Cost</th>
                <th className="text-left px-5 py-3.5 text-sm font-semibold text-foreground-700">Best For</th>
              </tr>
            </thead>
            <tbody>
              {methods.map((m, i) => (
                <tr key={m.method} className={`${i !== 0 ? "border-t border-background-200/40" : ""}`}>
                  <td className="px-5 py-3.5">
                    <span className="text-sm font-semibold text-foreground-900">{m.method}</span>
                  </td>
                  <td className="px-5 py-3.5 text-sm text-foreground-600">
                    <i className="ri-time-line mr-1.5 text-foreground-400"></i>
                    {m.time}
                  </td>
                  <td className="px-5 py-3.5">
                    <span className="text-sm font-semibold text-accent-600">{m.cost}</span>
                  </td>
                  <td className="px-5 py-3.5 text-sm text-foreground-600">{m.bestFor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}